import type { ReactNode } from "react";

import { cn } from "@flare/ui";

export function StepContainer({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "flex min-h-[calc(-55px+100svh)] flex-col justify-between pt-sp-6 md:min-h-[calc(-72px+100svh)] md:pt-sp-7",
        className,
      )}
    >
      {children}
    </div>
  );
}
